import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { Enquiryheader } from 'src/app/model/enquiryheader.model';
import { NgForm, FormsModule } from '@angular/forms';
import { Enquiryline } from 'src/app/model/enquiryline.model';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';

@Component({
  selector: 'app-pricequotevendor',
  templateUrl: './pricequotevendor.component.html',
  styleUrls: ['./pricequotevendor.component.css']
})
export class PricequotevendorComponent implements OnInit {

  stepno: string;
  enquiryData: any;
  enquiryHeader: Enquiryheader;

  data: Enquiryline[];
  isUserAdmin: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,
    private tenderingServices: TenderingService, private userService: UserService,
    private dataSharingService: DataSharingService) {
    this.stepno = this.route.snapshot.params.enquiryid;

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
        //alert(this.isUserAdmin);
      });

  }

  ngOnInit() {
    this.getEnquiryById();



  }

  getEnquiryById() {
    this.tenderingServices.GetEnquiryQuotesById(this.stepno).subscribe(
      datas => {
        this.enquiryData = datas;
        this.enquiryHeader = this.enquiryData;
        this.data = this.enquiryHeader.enquiryLine;

        console.log(this.data);
      }
    )
  }

  SubmitPriceQuoteForm(form: NgForm) {

    this.enquiryHeader.enquiryLine = this.data;
    if(this.isUserAdmin)
    {
      this.enquiryHeader.isQuoteApproved = true;
    }
    
    //this.enquiryHeader.quoteType = "price";
    //this.enquiryHeader.id = 0;
    // for(var i=0; i < this.enquiryHeader.enquiryLine.length; i++)
    // {
    //   this.enquiryHeader.enquiryLine[i].quoteType = "price";
    //   this.enquiryHeader.enquiryLine[i].vendorNo = this.enquiryHeader.vendorNo;
    //   this.enquiryHeader.enquiryLine[i].id = 0;
    // }

    //console.log(this.enquiryHeader);
    this.tenderingServices.SubmitPriceQuote(this.enquiryHeader).subscribe(
      data => {
        alert("Successfully Submitted");
      }
    );

  }

}
